module.exports = __webpack_public_path__ + "img/icon-ss.9d7113f3.png";